import './CreateEnv.scss'
import React ,{useEffect, useState, useContext} from 'react'
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Cookies from 'universal-cookie';
import { css } from "@emotion/react";
import functions from '../../functions/functions'
import Button from '../Button/Button';
import Switch from '@mui/material/Switch';
import infoIcon from '../../images/infoIcon.svg'
import Moment from 'moment'

const cookies = new Cookies();


export default function CreateEnv(props){

    const[branch_selected_frontend,set_branch_selected_frontend]=useState("workiz.com");
    const[branch_selected_backend,set_branch_selected_backend]=useState("workiz.com");
    const [custom_domain, set_custom_domain]=useState(cookies.get("login").toLowerCase());
    const[fronted_selected, set_frontend_selected]=useState(false);
    const[temp_env,set_temp_env]=useState(true);
    const[ custom_domain_selected, set_custom_domain_selected]=useState(false);
    const[valid_domain,set_valid_domain] = useState(true);
    const[domain_exists,set_domain_exists] = useState(false)
    const[searched_env,set_searched_env]=useState("");
    const[searched_env_details,set_searched_env_details]=useState(false);
    
    useEffect(() => {
        set_custom_domain(cookies.get("login").toLowerCase());
        cookies.set("domain",cookies.get("login").toLowerCase());
        console.log("front_default_props",props.front_default_props)
    },[])

    function handle_frontend_checkbox(e) {
        var value = e.target.value;
        set_frontend_selected(!fronted_selected);
    }

    useEffect(() => {
        if(searched_env){
            getDetails(searched_env)
        }
    },[searched_env])

    function handle_custom_domain_checkbox(e) {
        set_custom_domain_selected(!custom_domain_selected);
        if(custom_domain_selected){
            cookies.set("domain",cookies.get("login").toLowerCase());
            set_valid_domain(true)
        }
        else{
            set_valid_domain(false)
        }
    
    }

    function handle_temp_env_checkbox(e) {
        var value = e.target.value;
        set_temp_env(!temp_env);
    }

    function getDetails(env){
        var options = {
            'method': 'POST',
            'headers': {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "env": env,
            "code" : cookies.get("code")
          })
          };
          fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_details/" , options).then(response=>response.json())
          .then(async data=>{ 
            try{
              set_searched_env_details(data);
            }
            catch(error) {
              console.log('create debugger error', error);
            }
          });
    }

    function handle_custom_domain_text(e) {
        var value = e.target.value;
        set_custom_domain(value);
        cookies.set("domain",value);
        if(!functions.valid_domain_name(value)){
            set_valid_domain(false)
        }
        else{
            set_valid_domain(true)
        }
        if(functions.domain_exists(value, props.all_envs)){
            set_domain_exists(true)
        }
        else{
            set_domain_exists(false)
        }
    }

    async function trigger($selected_frontend,$selected_backend){
        props.setClicked(true)   
        var domain;
        if(custom_domain!=null && custom_domain_selected==true){
          domain=custom_domain;
        }
        else{
          domain=cookies.get("login").toLowerCase();
        }
        if(!fronted_selected){
          $selected_frontend="null"
        }
        const inputs= {"frontend": $selected_frontend ,"backend" : $selected_backend, "domain": domain ,"fronted_selected" : fronted_selected.toString() ,"temp_env" : temp_env.toString(),"login":cookies.get("login")}
        const response = await functions.create_new_env(inputs, "create_new_env.sh", cookies.get("login"), cookies.get("code"));  
        
    }

    const override = css`
        display: block;
        margin: 30 auto;
        border-color: red;
    `;
    return (
        <div style={{"width": "71%" , "height": "-webkit-fill-available" }}>
        <div className="col2">
            <div className="box">
                Choose branch for backend: 
                <Autocomplete
                    {...props.back_default_props}
                    autoSelect
                    size="small"
                    noOptionsText="loading more options..."
                    defaultValue="workiz.com"
                    sx={{ width: "471px" }}
                    onChange={(event, value) => set_branch_selected_backend(value)}
                    renderInput={(params) => (
                    <TextField {...params} />
                    )}
                /> 
            </div>
            <div className="switch_text">
            <Switch onChange={handle_frontend_checkbox} /> Add front
            </div>
            { fronted_selected==true && <div className="box" >
                Choose branch for frontend: 
                <Autocomplete
                    {...props.front_default_props}
                    autoSelect
                    size="small"
                    noOptionsText="loading more options..."
                    defaultValue="workiz.com"
                    sx={{ "width": "471px" }}
                    onChange={(event, value) => set_branch_selected_frontend(value)}
                    renderInput={(params) => (
                    <TextField {...params} />
                    )}
                /> 
            </div>
            }
            <div className="switch_text">
            <Switch onChange={handle_custom_domain_checkbox} /> Open a custom domain
            </div>
            { custom_domain_selected==true && <div className="box">
                Domain name
                <div>
                    <TextField id="outlined-basic" size="small" label="Env name" variant="outlined" onChange={handle_custom_domain_text} sx={{ "width": "471px" }}/>
                    { !valid_domain && 
                        <div className="warnning_msg">Domain should contain only lowercase letters and numbers </div>
                    }
                    {
                        domain_exists && valid_domain && 
                        <div className="warnning_msg">Domain already exists </div>
                    }
                    </div>
            </div>
            }

            <div className="switch_text">
                <Switch onChange={handle_temp_env_checkbox} /> Perm env
            </div>

            <div className="env_summery">
                <img src={infoIcon}/>
                <div>
                <div className="switch_text">We are going to build a new environment at {cookies.get("domain").toLowerCase()}.tests.workiz.com</div>
                {temp_env? (
                    <div>This env will stay for one week</div>
                ):(
                    <div>This env will stay until you delete it</div>
                )}
                </div>
            </div>
            <Button text="Create new env" style={{"marginTop": "2em" , "margin-left": "auto"}} loader={props.clicked} onClick={()=>trigger(branch_selected_frontend,branch_selected_backend)} disabled={props.clicked || !valid_domain || domain_exists} className="main"/>
         </div>
         <div className='col2'>
            <div>
                Search environment:
            </div>
            <div className='searchEnv'>
                <Autocomplete
                    {...props.all_envs_default_props}
                    autoSelect
                    size="small"
                    noOptionsText="loading more options..."
                    sx={{ width: "400px" , "margin-right": "1em"}}
                    onChange={(event, value) => set_searched_env(value)}
                    renderInput={(params) => (
                    <TextField {...params} />
                    )}
                />

            </div>
            {searched_env_details && <div className='details'>
                <div>Created at: <a className='switch_text'>{Moment(searched_env_details[0].created_at).format('LLL')}</a></div>
                <div>Backend branch: <a className='switch_text'>{searched_env_details[0].backend_branch}</a></div>
                <div>Backend last update: <a className='switch_text'>{Moment(searched_env_details[0].backend_last_update).format('LLL')}</a></div>
                {searched_env_details[0].frontend_branch != 'null' && <div>Frontend branch: <a className='switch_text'>{searched_env_details[0].frontend_branch}</a></div>}
                {searched_env_details[0].frontend_branch == 'null' && <div>Frontend branch: <a className='switch_text'>This env use workiz.com frontend</a></div>}
                {searched_env_details[0].frontend_branch != 'null' && <div>Frontend last update: <a className='switch_text'>{Moment(searched_env_details[0].frontend_last_update).format('LLL')}</a></div>}
                <div>Owners:
                    <div>
                        {searched_env_details[0].users.map((user) => (
                            <li key={user.slack_name}><a className='switch_text'>{user.slack_name}</a></li>
                        ))}
                    </div>
                </div>
                </div>}
         </div>
         </div>
    )
}